import { render } from "./ProductCreateComponent.vue?vue&type=template&id=87b43b7c"
import script from "./ProductCreateComponent.vue?vue&type=script&lang=js"
export * from "./ProductCreateComponent.vue?vue&type=script&lang=js"

import "./ProductCreateComponent.vue?vue&type=style&index=0&id=87b43b7c&lang=css"

import exportComponent from "C:\\Users\\webencusco\\Desktop\\projects vue3\\flawyer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__